<template>
  <div>
    <div class="p-5 h-[500px] overflow-y-auto xl:pb-1 pb-10">
      <div class="space-y-4">
        <div class="grid grid-cols-1 gap-5">
          <diffInput
            type="text"
            max="255"
            min="1"
            v-model="name"
            :required="true"
            title="Depo Adı"
            class="text-base"
          />
        </div>
        <div class="w-full grid grid-cols-2 gap-5">
          <diffInput
            v-model="startedDate"
            :max="complatedDate"
            type="datetime-local"
            :required="true"
            placeholder="Başlangıç Tarih"
            :min="minDate"
            title="Başlangıç Tarih"
          
          />
          
          <diffInput
            v-model="complatedDate"
            :min="startedDate ? startedDate : minDate"
            :max="maxDate"
            type="datetime-local"
            :required="true"
            :oldDate="true"
            placeholder="Bitiş Tarih"
            title="Bitiş Tarih"
            :disabled="!startedDate"
          />
        </div>
        <div class="w-full grid grid-cols-2 gap-5">
          <diffInput
            type="number"
            v-model="estimatedFillingTime"
            :required="true"
            title="Tahmini Dolum Süresi (Dakika)"
            :max="1500"
            :min="1"
            :step="1"
          />
          <diffInput
            type="number"
            v-model="estimatedDeliveryTime"
            :required="true"
            title="Tahmini Tahliye Süresi (Dakika)"
            :max="1500"
            :min="1"
            :step="1"
          />
        </div>
        <div class="w-full grid grid-cols-2 gap-5">
          <diffInput
            type="number"
            v-model="potCount"
            :required="true"
            title="Pot Sayısı (Dolum Noktasındaki tahliye vanası sayısı)"
            :max="50"
            :min="1"
            :step="1"
          />
          <diffInput
            type="number"
            v-model="minVehicleCount"
            :required="true"
            title="Dolum Noktasında Bulunması Gereken Minimum Araç Sayısı"
            :max="500"
            :min="1"
            :step="1"
          />
        </div>
        <!-- Atama Modu Seçimi -->
      <div class="w-full p-5 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
    <div class="flex items-center justify-between mb-4">
      <h4 class="text-lg font-medium text-gray-800 dark:text-gray-200">
        Araç Atama Modu
      </h4>
      <div class="bg-gray-100 dark:bg-gray-700 p-1 rounded-lg">
        <span :class="[
          'px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 inline-block',
          manualAssignmentMode === '0' 
            ? 'bg-red-600 text-white shadow-sm' 
            : 'text-gray-600 dark:text-gray-300'
        ]">
          Aktif Mod: {{ manualAssignmentMode === '0' ? 'Otomatik' : 'Manuel' }}
        </span>
      </div>
    </div>
    
    <div class="grid md:grid-cols-2 gap-3 mb-4">
      <label 
        :class="[
          'flex items-center justify-between p-3 border rounded-lg cursor-pointer transition-all duration-200',
          manualAssignmentMode === '0' 
            ? 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-700' 
            : 'bg-gray-50 dark:bg-gray-700 hover:bg-red-50 dark:hover:bg-red-900/10'
        ]"
      >
        <div class="flex items-center">
          <input 
            type="radio" 
            id="auto-mode" 
            name="assignment-mode" 
            value="0" 
            v-model="manualAssignmentMode"
            class="h-5 w-5 text-red-600 focus:ring-red-500 border-gray-300 dark:border-gray-600"
          />
          <div class="ml-3">
            <span class="block text-gray-800 dark:text-gray-200 font-medium">
              Otomatik Atama
            </span>
            <span class="text-xs text-gray-500 dark:text-gray-400">
              Sistem tarafından otomatik atama
            </span>
          </div>
        </div>
        <div v-if="manualAssignmentMode === '0'" class="flex-shrink-0 h-6 w-6 flex items-center justify-center bg-red-100 dark:bg-red-800 rounded-full">
          <i class="fas fa-check text-red-600 dark:text-red-400 text-sm"></i>
        </div>
      </label>

      <label 
        :class="[
          'flex items-center justify-between p-3 border rounded-lg cursor-pointer transition-all duration-200',
          manualAssignmentMode === '1' 
            ? 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-700' 
            : 'bg-gray-50 dark:bg-gray-700 hover:bg-red-50 dark:hover:bg-red-900/10'
        ]"
      >
        <div class="flex items-center">
          <input 
            type="radio" 
            id="manual-mode" 
            name="assignment-mode" 
            value="1" 
            v-model="manualAssignmentMode"
            class="h-5 w-5 text-red-600 focus:ring-red-500 border-gray-300 dark:border-gray-600"
          />
          <div class="ml-3">
            <span class="block text-gray-800 dark:text-gray-200 font-medium">
              Manuel Atama
            </span>
            <span class="text-xs text-gray-500 dark:text-gray-400">
              Kendiniz manuel olarak atayın
            </span>
          </div>
        </div>
        <div v-if="manualAssignmentMode === '1'" class="flex-shrink-0 h-6 w-6 flex items-center justify-center bg-red-100 dark:bg-red-800 rounded-full">
          <i class="fas fa-check text-red-600 dark:text-red-400 text-sm"></i>
        </div>
      </label>
    </div>

    <div class="mt-4 p-3 rounded-lg" :class="[
      manualAssignmentMode === '0' 
        ? 'bg-blue-50 dark:bg-blue-900/10 border border-blue-100 dark:border-blue-800' 
        : 'bg-amber-50 dark:bg-amber-900/10 border border-amber-100 dark:border-amber-800'
    ]">
      <div class="flex">
        <div class="flex-shrink-0">
          <i class="fas fa-info-circle mt-0.5" :class="[
            manualAssignmentMode === '0' 
              ? 'text-blue-500 dark:text-blue-400' 
              : 'text-amber-500 dark:text-amber-400'
          ]"></i>
        </div>
        <div class="ml-3">
          <p class="text-sm" :class="[
            manualAssignmentMode === '0' 
              ? 'text-blue-700 dark:text-blue-300' 
              : 'text-amber-700 dark:text-amber-300'
          ]">
            <span v-if="manualAssignmentMode === '1'">
              Manuel atama modunda, araçlar otomatik olarak siparişlere atanmayacak. Araçları siparişlere kendiniz manuel olarak atayacaksınız.
            </span>
            <span v-else>
              Otomatik atama modunda, araçlar sistem tarafından siparişlere otomatik olarak atanacaktır.
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
        
        <div class="w-full mt-4 grid grid-cols-1">
          <diffInput
            type="textarea"
            v-model="explanation"
            :title="$t('general.note')"
            maxlength="2800"
            :required="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Networking
import axios from "axios";
import { bulkShipPlanning } from "@/networking/urlmanager";

// Global Components
import diffInput from "@/components/general/diffInput.vue";

//Npm
import moment from "moment";

export default {
  name: "stepOnePage",
  components: {
    diffInput,
  },
  data() {
    return {
      name: "",
      startedDate: "",
      complatedDate: "",
      estimatedFillingTime: "",
      estimatedDeliveryTime: "",
      potCount: 0,
      minVehicleCount: 0,
      explanation: "",
      manualAssignmentMode: "0", // Otomatik atama modu varsayılan olarak seçili
      minDate: moment().format("YYYY-MM-DDT00:00"),
      maxDate: moment().add(2, 'years').format("YYYY-MM-DDT23:59")
    };
  },
  methods: {
    validateDates() {
      const today = moment();
      const start = moment(this.startedDate);
      const end = moment(this.complatedDate);
      if (start.isBefore(today, 'day')) {
        this.$swal({
          icon: 'error',
          title: 'Geçersiz Başlangıç Tarihi',
          text: 'Başlangıç tarihi bugünden önce olamaz.',
          confirmButtonText: 'Tamam'
        });
        return false;
      }
      if (end.isBefore(start, 'minute')) {
        this.$swal({
          icon: 'error',
          title: 'Geçersiz Bitiş Tarihi',
          text: 'Bitiş tarihi, başlangıç tarihinden sonra olmalıdır.',
          confirmButtonText: 'Tamam'
        });
        return false;
      }

      return true;
    },
    save(callback) {
      if (!this.validateDates()) {
        return callback(false);
      }

      axios
        .post(
          bulkShipPlanning.shipAdd,
          {
            typeId: 2,
            name: this.name,
            startedDate: this.startedDate,
            complatedDate: this.complatedDate,
            estimatedFillingTime: this.estimatedFillingTime,
            estimatedDeliveryTime: this.estimatedDeliveryTime,
            potCount: this.potCount,
            minVehicleCount: this.minVehicleCount,
            explanation: this.explanation,
            manualAssignmentMode: parseInt(this.manualAssignmentMode), // Manuel/Otomatik atama modu
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then((res) => {
          this.$emit("controllerPage", false);
          let insertId = res.data.data.insertId;
          this.$emit("estimatedTimes", {
            filling: this.estimatedFillingTime,
            delivery: this.estimatedDeliveryTime,
          });

          this.$emit("insertId", insertId);
          this.$emit("minVehicleCount", this.minVehicleCount);
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );

          this.$emit("refresh");
          callback(true);
        })
        .catch((err) => {
          this.errorBox(err.response);
          callback(false);
        });
    },
  },
};
</script>